import { render, staticRenderFns } from "./FollowUpDetail.vue?vue&type=template&id=68394fea&scoped=true"
import script from "./FollowUpDetail.vue?vue&type=script&lang=js"
export * from "./FollowUpDetail.vue?vue&type=script&lang=js"
import style0 from "./FollowUpDetail.vue?vue&type=style&index=0&id=68394fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68394fea",
  null
  
)

export default component.exports